import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useCart } from 'react-use-cart';

const MobileNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { totalItems } = useCart();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <nav className="mobile-navbar">
        <div className="mobile-navbar-content">
          <div className="brand">GOURMET</div>
          
          <div className="mobile-navbar-actions">
            <NavLink to="/cart" className="mobile-cart-icon">
              <i className="bi bi-cart3"></i>
              {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
            </NavLink>
            
            <button 
              className={`hamburger-btn ${isOpen ? 'active' : ''}`} 
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isOpen ? 'active' : ''}`} onClick={closeMenu}></div>

      {/* Mobile Menu Drawer */}
      <div className={`mobile-menu-drawer ${isOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <div className="brand">GOURMET</div>
          <button className="close-btn" onClick={closeMenu}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="mobile-nav-links">
          <NavLink 
            to="/" 
            className={({isActive}) => `mobile-nav-item ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            <i className="bi bi-house-door"></i> Home
          </NavLink>
          <NavLink 
            to="/menu" 
            className={({isActive}) => `mobile-nav-item ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            <i className="bi bi-grid"></i> Menu
          </NavLink>
          <NavLink 
            to="/about" 
            className={({isActive}) => `mobile-nav-item ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            <i className="bi bi-info-circle"></i> About
          </NavLink>
          <NavLink 
            to="/gallery" 
            className={({isActive}) => `mobile-nav-item ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            <i className="bi bi-images"></i> Gallery
          </NavLink>
          <NavLink 
            to="/contact" 
            className={({isActive}) => `mobile-nav-item ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
          >
            <i className="bi bi-envelope"></i> Contact
          </NavLink>
        </div>

        <div className="mobile-cart-widget">
          <div className="mb-2 text-secondary"><small>Your Order</small></div>
          <h3 className="text-white fw-bold">{totalItems} Item(s)</h3>
          <NavLink to="/cart" className="btn btn-gold w-100 mt-2" onClick={closeMenu}>
            View Cart
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default MobileNavbar;
